// import { useEffect, useRef, useState } from 'react';

// const useAutoTabSwitch = (tabCount = 0, delay = 4000, shouldRun = true) => {
//   const [currentTab, setCurrentTab] = useState(0);
//   const [isPaused, setIsPaused] = useState(false);
//   const intervalRef = useRef(null);
//   const pauseTimeoutRef = useRef(null);

//   const startTimer = () => {
//     if (!shouldRun || tabCount === 0 || isPaused) return;
    
//     // Clear existing timer first to prevent duplicates
//     clearTimer();
    
//     // console.log('Starting timer with delay:', delay);
//     intervalRef.current = setInterval(() => {
//       setCurrentTab(prev => {
//         const nextTab = (prev + 1) % tabCount;
//         // console.log('Auto-switching to tab:', nextTab);
//         return nextTab;
//       });
//     }, delay);
//   };

//   const clearTimer = () => {
//     if (intervalRef.current) {
//       console.log('Clearing timer');
//       clearInterval(intervalRef.current);
//       intervalRef.current = null;
//     }
//   };

//   const pauseTimer = () => {
//     // console.log('Pausing timer');
//     setIsPaused(true);
//     clearTimer();
//   };

//   const resumeTimer = () => {
//     // console.log('Resuming timer');
//     setIsPaused(false);
//     // Timer will start automatically via useEffect
//   };

//   const resetTimer = () => {
//     // console.log('Resetting timer');
//     clearTimer();
//     startTimer();
//   };

//   // Main effect for auto-switching
//   useEffect(() => {
//     if (shouldRun && tabCount > 0 && !isPaused) {
//       startTimer();
//     } else {
//       clearTimer();
//     }

//     return () => {
//       clearTimer();
//       if (pauseTimeoutRef.current) clearTimeout(pauseTimeoutRef.current);
//     };
//   }, [tabCount, delay, shouldRun, isPaused]); // Added isPaused dependency

//   // Manual tab click: pause auto-switch for 1 min
//   const manualSetTab = (newTab) => {
//     // console.log('Manual tab change to:', newTab);
//     setCurrentTab(newTab);
//     pauseTimer(); // Use pauseTimer instead of clearTimer

//     if (pauseTimeoutRef.current) clearTimeout(pauseTimeoutRef.current);

//     pauseTimeoutRef.current = setTimeout(() => {
//       // console.log('Resuming after manual pause');
//       resumeTimer();
//     }, 60000); // 1 min pause
//   };

//   return [currentTab, manualSetTab, { isPaused, pauseTimer, resumeTimer }];
// };

// export default useAutoTabSwitch;


import { useEffect, useRef, useState } from "react";

const useAutoTabSwitch = (tabCount = 0, delay = 4000, shouldRun = true) => {
  const [currentTab, setCurrentTab] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const intervalRef = useRef(null);

  const clearTimer = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  };

  const startTimer = () => {
    if (!shouldRun || isPaused || tabCount === 0) return;

    clearTimer();
    intervalRef.current = setInterval(() => {
      setCurrentTab((prev) => (prev + 1) % tabCount);
    }, delay);
  };

  const pauseTimer = () => {
    if (isPaused) return;
    setIsPaused(true);
    clearTimer();
  };

  const resumeTimer = () => {
    if (!isPaused) return;
    setIsPaused(false);
  };

  useEffect(() => {
    startTimer();
    return clearTimer;
  }, [isPaused, tabCount, delay, shouldRun]);

  return [currentTab, setCurrentTab, { pauseTimer, resumeTimer, isPaused }];
};

export default useAutoTabSwitch;
